/**
 * @generated SignedSource<<1a4d9b710dd6d20a842b517120613265>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpSharingIcons_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeartPill_viewer" | "NftHeartPillProvider_viewer">;
  readonly " $fragmentType": "NftPdpSharingIcons_viewer";
};
export type NftPdpSharingIcons_viewer$key = {
  readonly " $data"?: NftPdpSharingIcons_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpSharingIcons_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpSharingIcons_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeartPill_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftHeartPillProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "bce05e8ab2d8a84a829d7b9f724b2dc9";

export default node;
